import { useEffect, useRef, useState } from "react";

import { BoxedContent } from "@/components/common";
import { DynamicFormContainer } from "@/components/dynamic";
import dynamicObjectMap from "@/utils/maps/dynamicObjectMap";
import { useCompanyAccount, useTaskRedirect } from "@/hooks";

function ContactForm() {
  const ref = useRef(null);
  const [initialState, setInitialState] = useState({});
  const defaultAccounts = useCompanyAccount({
    params: {
      includeCompanyId: true,
      isLinkedWithRecord: false,
    },
  });
  const { redirect } = useTaskRedirect();

  useEffect(() => {
    if (defaultAccounts && !initialState.areAccountsSelected) {
      const { customerReceivable, customerRefund } = defaultAccounts;

      setInitialState((prevState) => ({
        ...prevState,
        areAccountsSelected: true,
        receivableAccount: customerReceivable,
        customerRefundAccount: customerRefund,
      }));
    }
  }, [defaultAccounts]);

  const onSuccess = (recordId) => {
    redirect(-1, {
      recordId,
      success: true,
    });
  };

  return (
    <BoxedContent>
      <DynamicFormContainer
        ref={ref}
        initialData={initialState}
        objectName={dynamicObjectMap.get("ContactObjectName")}
        showHeader
        navigate={false}
        onSuccess={onSuccess}
      />
    </BoxedContent>
  );
}

export default ContactForm;
